"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:import-blacklist */
var oauth_credentials_service_1 = require("@tableau/oauth-credentials-service");
var VizportalApi_1 = require("../vizportalapi/VizportalApi");
var CredentialsHandler;
(function (CredentialsHandler) {
    function getSessionRelevantInfo() {
        return __awaiter(this, void 0, void 0, function () {
            var sessionInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, VizportalApi_1.VizportalApiService.GetSessionInfo()];
                    case 1:
                        sessionInfo = _a.sent();
                        return [2 /*return*/, {
                                oauthSettings: sessionInfo.server.oauthSettings,
                                serverBuild: sessionInfo.server.version.build,
                                serverVersion: sessionInfo.server.version.platform,
                                langauge: sessionInfo.user.language,
                            }];
                }
            });
        });
    }
    CredentialsHandler.getSessionRelevantInfo = getSessionRelevantInfo;
    // adds credentials to the server using OAuthCredentialsService and gets the credential ID onCredentialAdded callback
    function addCredentialsSync(oauthCredentialsParams) {
        oauth_credentials_service_1.OAuthCredentialsService.AddCredential(oauthCredentialsParams);
    }
    CredentialsHandler.addCredentialsSync = addCredentialsSync;
    function addCredentialsAsync(oauthCredentialsParams) {
        return __awaiter(this, void 0, void 0, function () {
            var sleep, waitForWindowToCloseOrSeconds, credWindow, TEN_SECONDS;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sleep = function (ms) {
                            return new Promise(function (resolve) { return setTimeout(resolve, ms); });
                        };
                        waitForWindowToCloseOrSeconds = function (window, seconds) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(!credWindow.closed && seconds > 0)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, sleep(1000)];
                                    case 1:
                                        _a.sent(); // one second
                                        seconds--;
                                        return [3 /*break*/, 0];
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); };
                        credWindow = oauth_credentials_service_1.OAuthCredentialsService.AddCredential(oauthCredentialsParams);
                        TEN_SECONDS = 10;
                        return [4 /*yield*/, waitForWindowToCloseOrSeconds(credWindow, TEN_SECONDS)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    CredentialsHandler.addCredentialsAsync = addCredentialsAsync;
    function addCredentials(connectionType, helpVersion, 
    // tslint:disable-next-line:no-any
    onCredentialAdded, sessionRelevantInfo, jumpstartTelemetry, bypassBeforeConnectingDialog, handleOnProceedNoSignIn) {
        return __awaiter(this, void 0, void 0, function () {
            var oauthCredentialsParams;
            return __generator(this, function (_a) {
                oauthCredentialsParams = getOauthCredentialsParams(connectionType, helpVersion, onCredentialAdded, sessionRelevantInfo, jumpstartTelemetry, bypassBeforeConnectingDialog, handleOnProceedNoSignIn);
                oauth_credentials_service_1.OAuthCredentialsService.AddCredential(oauthCredentialsParams);
                return [2 /*return*/];
            });
        });
    }
    CredentialsHandler.addCredentials = addCredentials;
    function getOauthCredentialsParams(connectionType, helpVersion, 
    // tslint:disable-next-line:no-any
    onCredentialAdded, sessionRelevantInfo, jumpstartTelemetry, bypassBeforeConnectingDialog, handleOnProceedNoSignIn) {
        var supportsGenericAuth = false;
        sessionRelevantInfo.oauthSettings.forEach(function (oauthSetting) {
            if (oauthSetting.type === connectionType.internalName) {
                supportsGenericAuth = oauthSetting.supportsGenericAuth;
            }
        });
        return {
            bypassBeforeConnectingDialog: bypassBeforeConnectingDialog,
            connectionType: connectionType.internalName,
            connectionTypeDisplay: connectionType.displayName,
            sessionServerVersionBuild: sessionRelevantInfo.serverBuild,
            sessionServerVersionPlatform: sessionRelevantInfo.serverVersion,
            sessionLanguage: sessionRelevantInfo.langauge,
            helpServiceExternalVersion: helpVersion,
            supportsGenericAuth: supportsGenericAuth,
            onProceedNoSignIn: handleOnProceedNoSignIn,
            onCredentialAdded: onCredentialAdded,
            // onCancel is a required prop but we dont want to do anything.
            // tslint:disable-next-line:no-empty
            onCancel: function () { },
            // VPC does not support new relic so if jumspartTelemetry is not passed in we dont register anything.
            // tslint:disable-next-line:no-empty
            sendEventFn: jumpstartTelemetry ? jumpstartTelemetry.sendEventFromOAuth.bind(jumpstartTelemetry) : function () { },
            shouldKeepWindowOpen: false,
        };
    }
    CredentialsHandler.getOauthCredentialsParams = getOauthCredentialsParams;
})(CredentialsHandler = exports.CredentialsHandler || (exports.CredentialsHandler = {}));
//# sourceMappingURL=CredentialsHandler.js.map